
export const subscribeEmail = async values => {

	if (!values.email) {
		return res.status(400).json({
			error: 'Email is required'
		});
	}

	try {
		const API_KEY = BUTTONDOWN_API_KEY;
		const response = await fetch(
			`https://api.buttondown.email/v1/subscribers`, {
				body: JSON.stringify(values),
				headers: {
					Authorization: `Token ${API_KEY}`,
					'Content-Type': 'application/json'
				},
				method: 'POST'
			}
		);

		if (response.status >= 400) {
			return { error: 'erro, talvez o e-mail já esteja registado' }
		}

		return { error: '' };
	} catch (error) {
		return {
			error: error.message || error.toString()
		};
	}
};